import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { BY_KEY, HUB_KEYS } from '../../config/siteRegistry';

/**
 * Every hub as a plain crawlable link (label + one-line blurb), from the site
 * registry, so the hubs keep inbound links from the most-crawled page.
 */
export default function ExploreLinks() {
  return (
    <nav className="fi-explore" aria-labelledby="fi-explore-h" data-track-context="home_explore">
      <div className="fi-wrap">
        <h2 className="fi-h2" id="fi-explore-h">Explore the site</h2>
        <ul>
          {HUB_KEYS.map((k) => {
            const h = BY_KEY[k];
            return (
              <li key={k}>
                <RouterLink to={h.href}>
                  <b>{h.label.charAt(0).toUpperCase() + h.label.slice(1)}</b>
                  <span>{h.blurb}</span>
                </RouterLink>
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  );
}
